import { X } from 'lucide-react';
import { cn } from 'utils/cn';
import { Avatar, Badge } from '../index';
import { CustomBadgeProps } from '../MultiSelect';

export default function UserBadgeItem({ option, onUnselect, disabled, creatable }: CustomBadgeProps) {

    return (
        <Badge
            key={option.value}
            variant="tertiary"
            className={cn(
                'data-[disabled]:bg-muted-foreground data-[disabled]:hover:bg-muted-foreground data-[disabled]:text-muted px-2 py-1 gap-1',
                'data-[fixed]:bg-muted-foreground data-[fixed]:hover:bg-muted-foreground data-[fixed]:text-muted',
                'bg-background text-textcolor border border-border px-1',
                option.isContributor ? 'text-destructive' : '',
                creatable && (option.isvalidEmail ? '' : 'text-destructive')
            )}
            data-fixed={option?.fixed}
            data-disabled={disabled || undefined}
        >
            <Avatar
                className="h-[18px] w-[18px]"
                size="xs"
                title={option.label}
                src={option.src as string}
                email={option.email as string}
            />
            {option.label}
            <button
                className={cn(
                    'ring-offset-background focus:ring-ring rounded-full outline-none focus:ring-2 focus:ring-offset-2',
                    (disabled || option.fixed) && 'hidden'
                )}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onUnselect(option);
                    }
                }}
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                onClick={() => onUnselect(option)}
            >
                <X className="text-muted-foreground hover:text-foreground h-3 w-3" />
            </button>
        </Badge>
    );
};